export const generateOrgId = (id: string | number): string => {
  const strId = String(id);
  return strId.startsWith('org_') ? strId : `org_${strId}`;
};

export const generateUserId = (id: string | number): string => {
  const strId = String(id);
  return strId.startsWith('user_') ? strId : `user_${strId}`;
};

export const getEmployeeId = (id: string | number): string => {
  const strId = String(id);
  if (!isNaN(Number(id))) return strId;

  const splittedId = strId.split('_');
  return splittedId[1] || '--';
};

export const getUserIdWithoutPrefix = (ids: string[]): string[] => {
  return ids.map((id) => {
    const strId = String(id);
    return strId.startsWith('user_') ? strId.split('user_')[1] : strId;
  });
};
